<div class="registration-area">
    <div class="projects">
        <div class="project"></div>
        @for (project of projects(); track project.id) {
            @if (!project.children?.length) {
                <div
                    (click)="removeVisible(project)"
                    [class.hovered]="hoveredProject == project.id"
                    class="project"
                    title="{{project.company_name}} &raquo; {{project.name}}">
                    {{project.company_short ? project.company_short : project.company_name}} &raquo; {{project.name}}
                    <div class="totaltime">{{totalTime(project.id)}}</div>
                </div>
            }
            @if (project.children?.length) {
                @for (childProject of project.children; track childProject.id) {
                    @if (!childProject.children?.length) {
                        <div
                            (click)="removeVisible(childProject)"
                            [class.hovered]="hoveredProject == childProject.id"
                            class="project"
                            title="{{project.company_name}} &raquo; {{project.name}} &raquo; {{childProject.name}}">
                            {{project.company_short ? project.company_short : project.company_name}} &raquo; {{project.name}} &raquo; {{childProject.name}}
                            <div class="totaltime">{{totalTime(childProject.id)}}</div>
                        </div>
                    }
                    @if (childProject.children?.length) {
                        @for (subchildProject of childProject.children; track subchildProject.id) {
                            <div
                                (click)="removeVisible(subchildProject)"
                                [class.hovered]="hoveredProject == subchildProject.id"
                                class="project"
                                title="{{project.company_name}} &raquo; {{project.name}} &raquo; {{childProject.name}} &raquo; {{subchildProject.name}}">
                                {{project.company_short ? project.company_short : project.company_name}}
                                &raquo; {{project.name}} &raquo; {{childProject.name}} &raquo;
                                {{subchildProject.name}}
                                <div class="totaltime">{{totalTime(subchildProject.id)}}</div>
                            </div>
                        }
                    }
                }
            }
        }
    </div>
    <div
        #registrationhours
        (mousedown)="lg($event)"
        (mousemove)="lg($event)"
        (mouseup)="lg($event)"
        class="hours"
        id="registrationhours">
        <div [style.left.px]="getDifferenceInMinutes(currentTime, startTime) * 1.266666666" class="current-time"></div>
        <div class="project">
            @for (hour of hours(); track hour.getTime()) {
                <div [title]="hour | date: 'HH:mm'" class="hour">
                    {{hour | date: 'HH:mm'}}
                </div>
            }
        </div>
        @for (project of projects(); track project.id) {
            @if (!project.children?.length) {
                <div (mouseenter)="projectHover(project.id)" (mouseleave)="projectLeave()" class="project">
                    @for (quarter of quarters(); track quarter.time) {
                        <div
                            (contextmenu)="addComment(quarter, project)"
                            [attr.data-quarter]="quarter.time"
                            [attr.data-workproject]="project.id"
                            [class.full]="quarterIsWholeHour(quarter.time)"
                            [class.hascomment]="hasComment(quarter.time)"
                            [class.officetime]="officeTime(quarter.time)"
                            [class.selected]="quarterSelected(project.id, quarter.time)"
                            [title]="quarter.time | date: 'HH:mm'"
                            class="quarter">
                        </div>
                    }
                </div>
            }
            @if (project.children?.length) {
                @for (childProject of project.children; track childProject.id) {
                    @if (!childProject.children?.length) {
                        <div (mouseenter)="projectHover(childProject.id)" (mouseleave)="projectLeave()" class="project">
                            @for (quarter of quarters(); track quarter.time) {
                                <div
                                    (contextmenu)="addComment(quarter, project)"
                                    [attr.data-quarter]="quarter.time"
                                    [attr.data-workproject]="childProject.id"
                                    [class.full]="quarterIsWholeHour(quarter.time)"
                                    [class.hascomment]="hasComment(quarter.time)"
                                    [class.officetime]="officeTime(quarter.time)"
                                    [class.selected]="quarterSelected(childProject.id, quarter.time)"
                                    [title]="quarter.time | date: 'HH:mm'"
                                    class="quarter">
                                </div>
                            }
                        </div>
                    }
                    @if (childProject.children?.length) {
                        @for (subchildProject of childProject.children; track subchildProject.id) {
                            <div (mouseenter)="projectHover(subchildProject.id)" (mouseleave)="projectLeave()" class="project">
                                @for (quarter of quarters(); track quarter.time) {
                                    <div
                                        (contextmenu)="addComment(quarter, project)"
                                        [attr.data-quarter]="quarter.time"
                                        [attr.data-workproject]="subchildProject.id"
                                        [class.full]="quarterIsWholeHour(quarter.time)"
                                        [class.hascomment]="hasComment(quarter.time)"
                                        [class.officetime]="officeTime(quarter.time)"
                                        [class.selected]="quarterSelected(subchildProject.id, quarter.time)"
                                        [title]="quarter.time | date: 'HH:mm'"
                                        class="quarter">
                                    </div>
                                }
                            </div>
                        }
                    }
                }
            }
        }
    </div>
</div>
<div class="aspopup">
    @if (!isToday(selectedDate)) {
        <div class="alert alert-warning">
            <i class="fa fa-warning"></i> Selected date is not today
        </div>
    }
    @if (isWeekend(selectedDate)) {
        <div class="alert alert-warning">
            <i class="fa fa-warning"></i> Selected date is in weekend
        </div>
    }
    @if (showErrorMessage()) {
        <div class="alert alert-warning">
            @if (isFuture(selectedDate)) {
                <i class="fa fa-warning"></i> You cannot register hours in the future.
            } @else {
                <i class="fa fa-warning"></i> Hours can only be changed from {{ earliestEditableDate() | date:'E d MMM yyyy' }} onwards.
            }
        </div>
    }
</div>
<div class="toolbar">
    <div class="row gap-2 justify-content-between align-items-center">
        <div class="col-auto">
            <div class="d-flex align-items-center gap-2">
                <my-datepicker (dateModelChange)="selectedDateChanged($event)" [dateModel]="selectedDate"></my-datepicker>
                @if (!isToday(selectedDate)) {
                    <div (click)="today()" class="btn btn-light">Today</div>
                }
                <div (click)="continue()" class="btn btn-light">Continue</div>
                <div (click)="save()" class="btn btn-light">{{saveButtonText()}}</div>
                <div (click)="reload()" class="btn btn-reload btn-light">{{reloadButtonText}}</div>
            </div>
        </div>
        <div class="col-12 col-lg">
            <div class="row">
                <div class="col position-relative">
                    @if (searchNewProjects()?.length) {
                        <div class="newprojects">
                            @for (project of searchNewProjects(); track project.id) {
                                @if (!project.children?.length) {
                                    <div (click)="addVisible(project)" class="project" title="{{project.company_name}} &raquo; {{project.name}}">
                                        {{project.company_name}} &raquo; {{project.name}}
                                    </div>
                                }
                                @if (project.children?.length) {
                                    @for (childProject of project.children; track childProject.id) {
                                        @if (!childProject.children?.length) {
                                            <div (click)="addVisible(childProject)" class="project"
                                                 title="{{project.company_name}} &raquo; {{project.name}} &raquo; {{childProject.name}}">
                                                {{project.company_name}} &raquo; {{project.name}} &raquo;
                                                {{childProject.name}}
                                            </div>
                                        }
                                        @if (childProject.children?.length) {
                                            @for (subchildProject of childProject.children; track subchildProject.id) {
                                                <div
                                                    (click)="addVisible(subchildProject)"
                                                    class="project"
                                                    title="{{project.company_name}} &raquo; {{project.name}} &raquo; {{childProject.name}} &raquo; {{subchildProject.name}}">
                                                    {{project.company_name}} &raquo; {{project.name}} &raquo;
                                                    {{childProject.name}} &raquo; {{subchildProject.name}}
                                                </div>
                                            }
                                        }
                                    }
                                }
                            }
                        </div>
                    }
                    <input
                        [formControl]="searchNewProjectText"
                        class="form-control"
                        placeholder="Find a project..."
                        style="min-width: 12rem"
                        type="text"/>
                </div>
                <div class="col-auto">
                    <span class="totaltime flright">Today's total time: {{totalTime()}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<br/><br/>
<div class="row">
    <div class="col-6">
        <b>Usage:</b>
        <ul>
            <li><b>Click:</b> Simply register or unregister one quarter</li>
            <li><b>Ctrl + Click:</b> Unregister complete block</li>
            <li><b>Shift + Click:</b> Register from last registration until clicked quarter</li>
            <li><b>Continue:</b> Register from latest registration until now</li>
            <li><b>Right click:</b> Enter a comment (leave textarea empty to remove)</li>
            <li><b>Ctrl + S:</b> is the same action as the save button in the modal and at the bottom of the screen</li>
            <li><b>Can't find the task?:</b> Is the task a user story? Does it have a parent? If either of these is no you cannot find it until both are true</li>
        </ul>
    </div>
    <div class="col-6">
        <b>Comments:</b><br/>
        @for (entry of getCommentsArray(); track entry.key) {
            <li>
                <b>{{entry.key}}:</b> {{entry.value}}
            </li>
        }
    </div>
</div>

@if (showCommentModal) {
    <div class="modal fade show" role="dialog" style="display: block" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <div>
                        <h4 class="modal-title">
                            Commentaar bij uren om {{commentQuarter?.time | date: 'HH:mm'}} uur
                        </h4>
                        <span>Project: {{commentProject?.name}}</span>
                    </div>
                    <button (click)="showCommentModal = false" aria-label="Close" class="btn-close" type="button"></button>
                </div>
                <div class="modal-body">
                    <textarea #comment [formControl]="tempComment" class="form-control" rows="4"></textarea>
                </div>

                <div class="modal-footer justify-content-between">
                    <button (click)="clearComment()" class="btn btn-danger" type="button">
                        Verwijderen
                    </button>
                    <button (click)="setComment()" class="btn btn-primary" type="button">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
}
